import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 4B7C3083-DFDF-402E-9D71-CABE04305297
 * name alpha-g
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaGIcon = createSvgIcon(<><path d="M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V11H13V15H11V9H15V7H11Z" /></>, 'AlphaGIcon');
export default AlphaGIcon